import React, { useCallback, useEffect, useState } from "react";
import LeftSideNav from "../../../Components/LeftSideNav";
import TopNavBar from "../../../Components/TopNavbar";
import BreadcrumbsComponent from "../../../Components/BreadCrumbs";
import Colors from "../../../theme/Colors";
import Fonts from "../../../Config/Fonts";
import ManufactureTable from "./Controller/ManufactureTable";
import { useDispatch, useSelector } from "react-redux";
import { getUserDetailsAPI } from "../../../Store/Action/UserAction";
import { useNavigate } from "react-router-dom";
import { AppConstants } from "../../../Constants/AppConstants";
import CustomTopView from "../../../Components/CustomTopView";

const ManufacturesList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [breadcrumbs, setBreadcrumbs] = useState([]);
  const [pageNumber, setPageNumber] = useState(0);

  const { userData } = useSelector((state) => state.user);
  const [manufacturesData, setManufacturesData] = useState([]);
  const limit = AppConstants.limit;
  const rowsPerPageOptions = [25, 50, 100];
  const [totalCount, setTotalCount] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [searchQuery, setSearchQuery] = useState("");

  const rowsPerPageLabel = "User Per Page";

  const handleChangePage = useCallback((event, newPage) => {
    setPageNumber(newPage);
  }, []);

  const handleChangeRowsPerPage = useCallback((event) => {
    setRowsPerPage(event.target.value);
    setPageNumber(0);
  }, []);


  const handleSearchChange = useCallback((event) => {
    setSearchQuery(event.target.value);
    setPageNumber(0);
  }, []);

  useEffect(() => {
    setBreadcrumbs([
      { key: "1", href: "/manufacturesList", text: "Manufactures" },
    ]);
  }, []);

  const recordAfterSorting = manufacturesData?.slice(
    pageNumber * rowsPerPage,
    (pageNumber + 1) * rowsPerPage
  );

  useEffect(() => {
    // Create a parameter object with potentially missing values
    const params = {
      searchQuery: null || undefined,
      page: pageNumber || undefined,
      limit: limit || undefined
    };
  
    // Call the API with the parameter object
    dispatch(
      getUserDetailsAPI(params, (result) => {
        setManufacturesData(result?.data);
        setTotalCount(result?.totalCount);
      })
    );
  }, [dispatch, pageNumber, limit]);
  


   const onViewManufacturesDetails = useCallback(
    (manufacturesData) => {
      navigate(`/manufactureList/${manufacturesData?.manufacture_id}`, { state: { manufacturesData } });
    },
    [navigate]
  );

  return (
    <div style={mainContainerStyle}>
      <LeftSideNav />

      <div style={topContainerStyle}>
      <TopNavBar
          leftSideText={`Hello ${userData?.data?.user_first_name}`}
          isDashboard={true}
        />

        <CustomTopView
          breadcrumbs={breadcrumbs}
          addButtonText={"Add Manufacturer"}
          exportButtonText={"Export Manufacturer"}
          rowsPerPage={rowsPerPage}
          handleRowsPerPageChange={handleChangeRowsPerPage}
          rowPerPageLabel={rowsPerPageLabel}
          // onAddButtonClick={onAddCustomers}
          searchValue={searchQuery}
          onSearchChange={handleSearchChange}
          btnInputStyle={{
            width: '35%'
          }}
        />
        <div style={tableContainerStyle}>
          <ManufactureTable
            manufacturesData={recordAfterSorting}
            page={pageNumber}
            rowsPerPage={rowsPerPage}
            handleChangePage={handleChangePage}
            handleChangeRowsPerPage={handleChangeRowsPerPage}
            totalItems={totalCount}
            rowsPerPageOptions={rowsPerPageOptions}
            onViewManufacturesDetails={onViewManufacturesDetails}
          />
        </div>
      </div>
    </div>
  );
};

const mainContainerStyle = {
  display: "grid",
  gridTemplateColumns: "20% 80%",
  height: "100%",
  width: "100%",
  overflow: "hidden",
};

const topContainerStyle = {
  backgroundColor: Colors.bgColor,
  display: "flex",
  flexDirection: "column",
  height: "100%",
};

const tableContainerStyle = {
  width: "96%",
  height: "100%",
  marginLeft: "25px",
  borderRadius: "10px",
  margin: 20,
};


export default ManufacturesList;
